// extracted by mini-css-extract-plugin
export default {"statusDropdown":"CoLy0aAsBup7ftZmRbBc"};